export type Visibility = 'private' | 'shared' | 'company'

export function visibilityLabel(v: string): string {
  if (v === 'private') return 'личный'
  if (v === 'shared') return 'по ссылке'
  if (v === 'company') return 'компания'
  return v
}

export function visibilityHint(v: Visibility): string {
  if (v === 'private') return 'личный — только я (+явный доступ)'
  if (v === 'shared') return 'по ссылке / участникам'
  return 'вся компания'
}

export function visibilityBadgeClass(v: Visibility): string {
  if (v === 'private') return 'badge badge-private'
  if (v === 'shared') return 'badge badge-shared'
  return 'badge badge-company'
}

export function itemStatusLabel(
  status: 'available' | 'reserved',
  opts: { isOwner: boolean; reservedByName?: string | null },
): string {
  if (status !== 'reserved') return 'свободно'
  if (opts.isOwner) return 'забронировано'
  if (opts.reservedByName) return `бронь · ${opts.reservedByName}`
  return 'забронировано'
}
